import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { cn } from '@utils/Cn.js';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
  className?: string;
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className={cn(
        'rounded-[28px] border border-dashed border-line-strong bg-surface/90',
        'px-6 py-14 text-center shadow-[0_4px_24px_rgba(12,23,44,0.06)]',
        className,
      )}
    >
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-paper text-slate border border-line">
        <Icon size={26} strokeWidth={1.5} />
      </div>
      <h3 className="text-base font-bold tracking-tight text-ink">{title}</h3>
      <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-ink-faint">{description}</p>
      {action && <div className="mt-5">{action}</div>}
    </motion.div>
  );
}
